import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GanjikaBeverageCardData } from '../../../../../../../models/print-cards/ganjika-beverage-card-data';
import { PrimaryCannabinoid } from 'src/app/models/enum/shared/cannabinoid';
import { SortUtils } from 'src/app/utils/sort-utils';

@Injectable()
export class GanjikaBeverageAddressCardStackContentViewModel extends PrintCardContentViewModel {
  public readonly cardData$: Observable<GanjikaBeverageCardData>;

  public override virtualLabelText$ = this._virtualLabelText.pipe(
    map(virtualLabelText => {
      // If Ganjika House uses special terms to capture special sales, check against virtualLabelText
      return 'NOW';
    })
  );

  public thcAndCbdFirstPropertiesFromPool$ = this.propertiesBasedOnPools$.pipe(
    map(properties => {
      const pinnedMap = new Map<string, number>([
        [PrimaryCannabinoid.THC, 0],
        [PrimaryCannabinoid.CBD, 1]
      ]);
      return [...properties].sort((a, b) => {
        return SortUtils.pinned(pinnedMap, a.title, b.title);
      });
    })
  );
}
